// mission-required-hook-files.ts
//
// Split out of mission-settings-profile.ts (review 06g M1, ≤ 200 lines) —
// pure data, no I/O. Imported by mission-workspace-hooks.ts (builds the
// `hooks` block from the pinned pack) and session-preflight-checks.ts.

/**
 * Hook autopilot BẮT BUỘC có trong mission, đường dẫn TƯƠNG ĐỐI so với gốc pack
 * đã ghim (`<worktree>/.claude/pack/`).
 *
 * Audit 2026-09-14 (F4): mission trước đây đăng ký 0 hook. Fix là allowlist
 * TƯỜNG MINH chứ KHÔNG bê nguyên khối `hooks` của `templates/settings.json.tpl`
 * — template đó phục vụ phiên CÓ NGƯỜI và mang 2 hook giết mission headless:
 *
 *   - `pretooluse-repo-write-lock-hook.py` trả `permissionDecision:"ask"` khi
 *     lock conflict. Worker headless không ai bấm Yes ⇒ treo.
 *   - `sessionend-release-repo-lock.py` đi ngược lên tìm `.git` ĐẦU TIÊN; từ
 *     worktree mission, đó là repo CHA của người dùng ⇒ xoá lock của họ.
 *   - inject plan-stage + `dev-rules-reminder.cjs` (UserPromptSubmit) vô nghĩa:
 *     phiên headless không có prompt người.
 *
 * Hai hook giữ lại chỉ `deny` hoặc passthrough dưới binding hợp lệ — không bao
 * giờ `ask` (dangerous-guard đổi `ask`→`deny` khi có binding).
 *
 * Đặt ở module THUẦN này (không phải mission-workspace.ts) để
 * session-preflight-checks.ts dùng chung mà không kéo theo I/O dựng worktree.
 *
 * Đánh đổi đã biết: pack thêm hook guard mới thì mission KHÔNG tự nhận, phải
 * cập nhật danh sách này bằng tay. Chấp nhận, đổi lại mission không tự treo.
 */
export const AUTOPILOT_REQUIRED_HOOK_FILES = [
  "hooks/pretooluse-dangerous-command-guard-hook.py",
  "tools/why-how-what-confirm/hooks/pretooluse-block-until-user-confirms-plan.py",
] as const;
